"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDynamicColumnClient = useDynamicColumnClient;
const DynamicColumnClient_1 = require("@juvare/platform-sdk-js/DynamicColumnClient");
const react_1 = __importDefault(require("react"));
function useDynamicColumnClient(baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new DynamicColumnClient_1.DynamicColumnClient(baseUrl, tokenProvider), [baseUrl, tokenProvider]);
}
